module.exports = __webpack_public_path__ + "assets/img/activity_618_bg2.4d9862b8.png";